import { asApr } from "@silo/utils";
import { MerklRewardLegacy } from "@silo/types";
import { getDepositAprMetrics } from "./utils";
import { classNames } from "../../utils/class-names";

interface DepositTotalProps {
  depositApr: bigint;
  depositRewardsApr: bigint;
  rewardsSymbol: string;
  merklRewards: MerklRewardLegacy[];
  ["data-cy"]?: string;
  isProtected: boolean;
  className?: string;
  displayProtectedAsNil?: boolean;
}

export function DepositTotal({
  depositApr,
  depositRewardsApr,
  rewardsSymbol,
  merklRewards,
  isProtected,
  ["data-cy"]: dataCy,
  className,
  displayProtectedAsNil = false,
}: DepositTotalProps): JSX.Element {
  const metrics = getDepositAprMetrics({
    depositApr,
    depositRewardsApr,
    isProtected,
    rewardsSymbol,
    merklRewards,
  });

  const { hasDepositApr, totalDepositApr, hasDepositRewardsApr } = metrics;

  if (!hasDepositApr && displayProtectedAsNil) {
    return (
      <dd
        data-cy={dataCy}
        className={classNames("font-mono font-medium", className)}
      >
        --
      </dd>
    );
  }

  return (
    <dd
      data-cy={dataCy}
      className={classNames(
        "font-mono text-2xl font-medium",
        hasDepositRewardsApr ? "text-amber-300" : "text-white",
        className
      )}
    >
      {hasDepositRewardsApr && "+"}
      {asApr(totalDepositApr)}
    </dd>
  );
}
